import {
  getRequest,
  patchRequest,
  postRequest,
  formatRequestError,
} from "../../../utils/requests";
import config from "../../../config.json";
import { message } from "antd";

export const fetchUsers = (setUsers = () => {}, setIsLoading = () => {}) => {
  const url = `${config.service}/api/user`;
  setIsLoading(true);

  const response = getRequest(url);

  response
    .then((data) => {
      setUsers(data.data.users);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const fetchCompanyUsers = (
  id,
  setUsers = () => {},
  setIsLoading = () => {}
) => {
  const url = `${config.service}/api/user/company/${id}`;
  setIsLoading(true);

  const response = getRequest(url);

  response
    .then((data) => {
      setUsers(data.data);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const updateUser = async (id, body, onFinish = () => {}) => {
  const url = `${config.service}/api/user/${id}`;

  const hideLoadingMsg = message.loading("Обновляется", 0);

  const response = patchRequest(url, body);

  try {
    await response.then(() => {});

    await patchRequest(`${config.service}/api/permission/user/${id}`, body);

    message.success("Пользователь успешно обновлен", 2);
    hideLoadingMsg();
    onFinish();
  } catch (e) {
    hideLoadingMsg();
    message.error(formatRequestError("Не удалось обновить пользователя", e), 2);
  }
};

export const fetchCompanies = (
  setCompanies = () => {},
  setIsLoading = () => {}
) => {
  const url = `${config.service}/api/company`;
  setIsLoading(true);

  const response = getRequest(url);

  response
    .then((data) => {
      setCompanies(data.data);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const createCompany = (
  body,
  setIsLoading = () => {},
  setCompanies = () => {}
) => {
  const hideLoadingMsg = message.loading("Сохраняется", 0);

  const url = `${config.service}/api/company`;

  const response = postRequest(url, body);

  response
    .then(() => {
      message.success("Компания успешно создана", 2);

      fetchCompanies(setCompanies);
    })
    .catch((err) => {
      message.error(formatRequestError("Не удалось сохранить компанию", err), 2);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const createUser = (body, onFinish) => {
  const hideLoadingMsg = message.loading("Сохраняется", 0);

  const url = `${config.service}/api/user`;

  const response = postRequest(url, body);

  response
    .then(() => {
      message.success("Пользователь успешно создан", 2);

      onFinish();
    })
    .catch((err) => {
      message.error(
        formatRequestError("Не удалось сохранить пользователя", err),
        2
      );
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const fetchRoles = (setRoles = () => {}, setIsLoading = () => {}) => {
  const url = `${config.service}/api/role`;
  setIsLoading(true);

  const response = getRequest(url);

  response
    .then((data) => {
      setRoles(data.data);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const fetchCompanyPermissions = (
  companyId,
  setCompanyPermissions = () => {},
  setIsLoading = () => {}
) => {
  const url = `${config.service}/api/permission/company/${companyId}`;

  getRequest(url)
    .then((data) => {
      setCompanyPermissions(data.data);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

// Получить количество лидов и клиентов пользователя
export const fetchUserLeadsAndClients = async (userId) => {
  const url = `${config.service}/api/user/${userId}/leads-clients-count`;
  
  try {
    const response = await getRequest(url);
    return response.data || { leadsCount: 0, clientsCount: 0 };
  } catch (error) {
    return { leadsCount: 0, clientsCount: 0 };
  }
};

// Получить список активных менеджеров из отделов продаж
// Фильтр по companyId (отделы продаж)
export const fetchSalesManagers = async (excludeUserId = "") => {
  const url = `${config.service}/api/user/sales-managers?excludeUserId=${excludeUserId}`;
  
  try {
    const response = await getRequest(url);
    // Поддержка разных форматов ответа
    const managers = response.data?.data || response.data || [];
    return Array.isArray(managers) ? managers : [];
  } catch (error) {
    message.error(
      formatRequestError("Не удалось загрузить список менеджеров", error),
      2
    );
    return [];
  }
};

// Переназначить лиды и клиенты на другого менеджера
export const reassignLeadsAndClients = async (fromUserId, toUserId) => {
  const hideLoadingMsg = message.loading("Переназначение лидов и клиентов...", 0);
  const url = `${config.service}/api/user/${fromUserId}/reassign`;
  
  try {
    await postRequest(url, { targetUserId: toUserId });
    hideLoadingMsg();
    message.success("Лиды и клиенты успешно переназначены", 2);
    return true;
  } catch (error) {
    hideLoadingMsg();
    message.error(
      formatRequestError("Не удалось переназначить лиды и клиенты", error),
      2
    );
    return false;
  }
};
